import { render, staticRenderFns } from "./WrapFlex.vue?vue&type=template&id=54557198"
var script = {}
import style0 from "./WrapFlex.vue?vue&type=style&index=0&id=54557198&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports